import { render, staticRenderFns } from "./Recorded.vue?vue&type=template&id=2593119c&scoped=true&"
import script from "./Recorded.vue?vue&type=script&lang=js&"
export * from "./Recorded.vue?vue&type=script&lang=js&"
import style0 from "./Recorded.vue?vue&type=style&index=0&id=2593119c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593119c",
  null
  
)

export default component.exports